import { render, staticRenderFns } from "./CancelFileMovementModal.vue?vue&type=template&id=2b912c60&"
import script from "./CancelFileMovementModal.vue?vue&type=script&lang=js&"
export * from "./CancelFileMovementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports